export abstract class AuthSsoState {
  private static readonly storageKey: string = "ssoProvider"

  public static get(): string | undefined {
    return localStorage.getItem(AuthSsoState.storageKey) ?? undefined;
  }

  public static set(value: string) {
    localStorage.setItem(AuthSsoState.storageKey, value);
  }

  public static clear() {
    localStorage.removeItem(AuthSsoState.storageKey);
  }
}
